import { Component, Input } from '@angular/core';

import { FormData } from '../../../classes/data';
import { FormSchema } from '../../../classes/schema';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-button',
  templateUrl: './input-button.component.html'
})
export class InputButtonComponent {
  @Input() public form: FormData;
  @Input() public schema: FormSchema;

  constructor() { }
}
